<template>
    <div>
        <base-header class="pb-6" type="">
            <b-row class="align-items-center py-4">
            <b-col lg="12" cols="12">
                <!-- <h6 class="h2 text-white d-inline-block mb-0">{{$route.name}}</h6> -->
                <h6 class="h2 d-inline-block mb-0">{{language_terms[$route.name]}}</h6>
                <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                <route-breadcrumb/>
                </nav>
            </b-col>
            </b-row>
      </base-header> 
        <b-container fluid class="mt--6">
            <div>
                <loading :active.sync="loading" 
                    color= '#007bff'
                    :width= '128'
                    :height= '128'
                    loader='dots'
                    :can-cancel="true" 
                    :is-full-page="true">
                    </loading>
                </div>
                <b-card>
                    <div slot="header" class="mb-0">
                        <h3>{{language_terms['QUICK_SEARCH']}}</h3>
                    </div>
                    <b-row>
                        <b-col cols="7">
                            <base-input :label="language_terms['QUICK_FILTER']" v-model="filter.keyword" v-on:keyup.enter="clickOnSearch"></base-input>
                        </b-col>
                        <b-col md="2">
                            <base-input :label="language_terms['DATE_FROM']" >
                                <flat-picker
                                    slot-scope="{ focus, blur }"
                                    @on-open="focus"
                                    @on-close="blur"
                                    style="background-color: white"
                                    class="form-control datepicker"
                                    v-model="filter.date_from">
                                </flat-picker>
                            </base-input>
                        </b-col>
                        <b-col md="2">
                            <base-input :label="language_terms['DATE_TO']" >
                                <flat-picker
                                    slot-scope="{ focus, blur }"
                                    @on-open="focus"
                                    @on-close="blur"
                                    style="background-color: white"
                                    class="form-control datepicker"
                                    v-model="filter.date_to">
                                </flat-picker>
                            </base-input>
                        </b-col>
                        <b-col cols="1" class="mt-4">
                              <base-button type="primary" @click="clickOnSearch" class="mt-2">{{language_terms['SEARCH']}}</base-button>
                          </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12">
                            <PaginatedTables :myColumns="tableColumns" :tableData="items" 
                            :cardTitle="language_terms['SEARCH_RESULTS']" v-if="items.length > 0" v-on:showDetails="showRowDetails"/>
                        </b-col>
                    </b-row>
                </b-card>
                <b-modal v-model="rowDetailsModal" :header-bg-variant="headerBgVariant" :header-text-variant="headerTextVariant" size="xl" centered class="my-modal" ok-only>
                    <template #modal-title>
                        <span style="color: white">{{language_terms['INVENTORY_DETAILS']}}</span>
                    </template>
                     <b-col lg="12" class="mb-3">
                         <div class="table-responsive">
                            <PaginatedTables :myColumns="itemFields" :tableData="item_details" 
                                :cardTitle="language_terms['SEARCH_RESULTS']" v-if="item_details.length > 0"/>
                         </div>

                     </b-col>
                </b-modal>
        </b-container>
    </div>
</template>

<script>
import { mapState } from 'vuex';

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css'; 

import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Select, Option } from "element-ui";

import PaginatedTables from '@/views/Tables/PaginatedTables'

export default {
    computed:{
        ...mapState({
            language_terms:(state)=>state.languages.language_terms,
            items: (state) => state.stockcards.inventory,
            item_details: (state) => state.stockcards.inventory_details,
            filter_data: (state) => state.stockcards.filter_inventory
        })
    },
    components: {
    Loading,
    flatPicker,
    [Select.name]: Select,
    [Option.name]: Option,
    PaginatedTables
  },
  data()
  {
      return{
          loading:false,
          headerBgVariant: "primary",
          headerTextVariant: "light",
          rowDetailsModal:false,
          selectedRow:{},
          filter:{
              keyword:"",
              date_from:'',
              date_to:''
          },
          itemFields:[
            {
                prop: "location_name",
                label: "LOCATION",
                minWidth: 50,
                sortable: true,
                key:"LOCATION"
            },
            {
                prop: "product_code",
                label: "PRODUCT_CODE",
                minWidth: 80,
                sortable: true,
                key:"PRODUCT_CODE"
            },
            {
                prop: "product_name",
                label: "PRODUCT_NAME",
                minWidth: 680,
                sortable: true,
                key:"PRODUCT_NAME"
            },
            {
                prop: "qty",
                label: "QTY",
                sortable: true,
                key:"QTY"
            },
            {
                prop: "lot_reference",
                label: "LOT_NUMBER",
                sortable: true,
                key:"LOT_NUMBER"
            },
            {
                prop: "expiry_date",
                label: "EXPIRY",
                sortable: true,
                key:"EXPIRY"
            },
        
          ],
          tableColumns: [
            {
                prop: "product_code",
                label: "PRODUCT_CODE",
                minWidth: 120,
                sortable: true,
                key:"PRODUCT_CODE"
            },
            {
                prop: "product_name",
                label: "PRODUCT_NAME",
                minWidth: 480,
                sortable: true,
                key:"PRODUCT_NAME"
            },
            {
                prop: "qty",
                label: "QTY",
                sortable: true,
                key:"QTY"
            },
            // {
            //     prop: "location_count",
            //     label: "LOCATIONS",
            //     sortable: true,
            //     key:"LOCATIONS"
            // },
            // {
            //     prop: "lot_count",
            //     label: "LOT_COUNT",
            //     sortable: true,
            //     key:"LOT_COUNT"
            // },
            // {
            //     prop: "date_range",
            //     label: "DATE_RANGE",
            //     sortable: true,
            //     key:"DATE_RANGE"
            // }
        ]
      }
  },
  watch:{
     language_terms: {
          handler(val){
              this.updateTableLang()
          }
        },
    },
  methods:{
    updateTableLang()
    {
        for(let i=0; i < this.tableColumns.length;i++)
        {
            let key = this.tableColumns[i].key
            this.tableColumns[i].label = this.language_terms[key]
        }

        for(let i=0; i < this.itemFields.length;i++)
        {
            let key = this.itemFields[i].key
            this.itemFields[i].label = this.language_terms[key]
        }
    },
    async clickOnSearch()
    {
        await this.$store.dispatch("stockcards/quickSearchInventory", this.filter);
    },
    async showRowDetails(row)
    {
        if(row)
        {
            this.loading = true
            this.selectedRow = row
            let payload = {product_id:row.product_id, product_name: row.product_name}
            await this.$store.dispatch("stockcards/getInventoryDetails", payload);
            this.loading = false
            this.rowDetailsModal = true

        }
    }
  },
  mounted()
  {
      this.updateTableLang()
  }
}
</script>
